<div class="container mx-auto px-4 py-6">
  <!-- Header -->
  <div class="mb-8">
    <h1 class="text-2xl font-bold text-gray-900">Nuevo Retiro de Inscripción</h1>
    <p class="text-gray-600 mt-1">Castigar cartera de cuotas pendientes por retiro del estudiante</p>
  </div>

  <!-- Stepper -->
  <div class="mb-8">
    <div class="flex items-center justify-between">
      <div class="flex items-center" *ngFor="let step of [1, 2, 3, 4]; let i = index">
        <div class="flex items-center">
          <div 
            [ngClass]="{
              'bg-green-600 text-white': currentStep === 4 && operationSuccess && step === 4,
              'bg-red-600 text-white': currentStep === 4 && !operationSuccess && step === 4,
              'bg-blue-600 text-white': currentStep >= step && !(currentStep === 4 && step === 4),
              'bg-gray-200 text-gray-600': currentStep < step
            }"
            class="w-10 h-10 rounded-full flex items-center justify-center font-semibold">
            <span *ngIf="!(currentStep === 4 && step === 4)">{{ step }}</span>
            <svg *ngIf="currentStep === 4 && step === 4 && operationSuccess" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
            </svg>
            <svg *ngIf="currentStep === 4 && step === 4 && !operationSuccess" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </div>
          <span class="ml-2 text-sm font-medium hidden md:inline" 
                [ngClass]="{'text-blue-600': currentStep >= step, 'text-gray-500': currentStep < step}">
            {{ step === 1 ? 'Seleccionar' : step === 2 ? 'Cuotas' : step === 3 ? 'Confirmar' : 'Resultado' }}
          </span>
        </div>
        <div *ngIf="i < 3" class="w-12 md:w-20 h-1 mx-2 md:mx-4" 
             [ngClass]="{'bg-blue-600': currentStep > step, 'bg-gray-200': currentStep <= step}"></div>
      </div>
    </div>
  </div>

  <!-- Paso 1: Buscar y seleccionar inscripción -->
  <div *ngIf="currentStep === 1" class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-lg font-semibold mb-4">Buscar Participante</h2>
    
    <form [formGroup]="searchForm" (ngSubmit)="searchParticipant()" class="mb-6">
      <div class="flex gap-4">
        <input 
          type="text" 
          formControlName="searchTerm"
          placeholder="Buscar por nombre o documento..."
          class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
        <button 
          type="submit" 
          [disabled]="isSearching || searchForm.invalid"
          class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed">
          <span *ngIf="isSearching">Buscando...</span>
          <span *ngIf="!isSearching">Buscar</span>
        </button>
      </div>
    </form>

    <!-- Lista de participantes -->
    <div *ngIf="searchPerformed && participants.length > 0" class="mb-6">
      <h3 class="text-sm font-medium text-gray-700 mb-2">Participantes encontrados:</h3>
      <div class="space-y-2 max-h-60 overflow-y-auto">
        <div 
          *ngFor="let p of participants" 
          (click)="selectParticipant(p)"
          [ngClass]="{'ring-2 ring-blue-500 bg-blue-50': selectedParticipantId === p.id}"
          class="p-3 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
          <div class="font-medium">{{ p.firstName }} {{ p.lastName }}</div>
          <div class="text-sm text-gray-500">{{ p.typeDocument }}: {{ p.documentId }} | {{ p.email }}</div>
        </div>
      </div>
    </div>

    <div *ngIf="searchPerformed && participants.length === 0 && !isSearching" class="text-center py-8 text-gray-500">
      No se encontraron participantes con ese criterio de búsqueda
    </div>

    <!-- Lista de inscripciones activas -->
    <div *ngIf="enrollments.length > 0" class="mt-6">
      <h3 class="text-sm font-medium text-gray-700 mb-2">Inscripciones activas:</h3>
      <div class="space-y-3">
        <div 
          *ngFor="let e of enrollments"
          (click)="selectEnrollment(e)"
          [ngClass]="{'opacity-50 cursor-not-allowed': !e.canBeWithdrawn}"
          class="p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
          <div class="flex justify-between items-start">
            <div>
              <div class="font-medium">{{ e.projectMnemonic }} - {{ e.projectName }}</div>
              <div class="text-sm text-gray-500">{{ e.participantName }}</div>
            </div>
            <span class="px-2 py-1 text-xs rounded-full" 
                  [ngClass]="{'bg-green-100 text-green-800': e.canBeWithdrawn, 'bg-gray-100 text-gray-600': !e.canBeWithdrawn}">
              {{ e.pendingInstallments }} cuotas pendientes
            </span>
          </div>
          <div class="mt-2 text-sm">
            <span class="text-gray-600">Total: </span>
            <span class="font-medium">{{ e.currencySymbol }}{{ e.totalAmount | number:'1.2-2' }}</span>
            <span class="text-gray-600 ml-4">Saldo: </span>
            <span class="font-medium text-red-600">{{ e.currencySymbol }}{{ e.remainingBalance | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading" class="text-center py-8">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
      <p class="mt-2 text-gray-500">Cargando...</p>
    </div>
  </div>

  <!-- Paso 2: Revisar cuotas a castigar -->
  <div *ngIf="currentStep === 2 && selectedEnrollment" class="bg-white rounded-lg shadow-md p-6">
    <div class="mb-6">
      <h2 class="text-lg font-semibold">Revisar Plan de Pagos</h2>
      <p class="text-gray-600">{{ selectedEnrollment.participantName }} - {{ selectedEnrollment.projectName }}</p>
    </div>

    <div class="flex justify-between items-center mb-4">
      <span class="text-sm text-gray-600">Seleccione las cuotas a castigar:</span>
      <div class="space-x-2">
        <button (click)="selectAllInstallments()" class="text-sm text-blue-600 hover:text-blue-800">Seleccionar todas</button>
        <button (click)="deselectAllInstallments()" class="text-sm text-gray-600 hover:text-gray-800">Deseleccionar</button>
      </div>
    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <input 
                type="checkbox" 
                [checked]="allInstallmentsSelected"
                (change)="toggleSelectAll()"
                class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
            </th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cuota</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Vencimiento</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monto</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pagado</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pendiente</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let pp of selectedEnrollment.pendingPaymentPlans" 
              [ngClass]="{'bg-blue-50': isInstallmentSelected(pp.paymentPlanId), 'opacity-50': pp.isPunished}">
            <td class="px-4 py-3">
              <input 
                type="checkbox" 
                [checked]="isInstallmentSelected(pp.paymentPlanId)"
                [disabled]="pp.isPunished"
                (change)="toggleInstallment(pp.paymentPlanId)"
                class="rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:opacity-50">
            </td>
            <td class="px-4 py-3 text-sm font-medium text-gray-900">{{ pp.installmentNumber }}</td>
            <td class="px-4 py-3 text-sm text-gray-500">{{ pp.dueDate | date:'dd/MM/yyyy' }}</td>
            <td class="px-4 py-3 text-sm text-gray-900">{{ selectedEnrollment.currencySymbol }}{{ pp.amountToPay | number:'1.2-2' }}</td>
            <td class="px-4 py-3 text-sm text-green-600">{{ selectedEnrollment.currencySymbol }}{{ pp.amountPaid | number:'1.2-2' }}</td>
            <td class="px-4 py-3 text-sm text-red-600 font-medium">{{ selectedEnrollment.currencySymbol }}{{ pp.pendingAmount | number:'1.2-2' }}</td>
            <td class="px-4 py-3">
              <span class="px-2 py-1 text-xs rounded-full" 
                    [ngClass]="{
                      'bg-red-100 text-red-800': pp.isOverdue,
                      'bg-yellow-100 text-yellow-800': pp.paymentStatus === 'PENDING' && !pp.isOverdue,
                      'bg-gray-100 text-gray-800': pp.isPunished
                    }">
                {{ pp.isPunished ? 'Castigada' : (pp.isOverdue ? 'Vencida (' + pp.daysOverdue + ' días)' : pp.paymentStatusDescription) }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Resumen -->
    <div class="mt-6 p-4 bg-red-50 rounded-lg">
      <div class="flex justify-between items-center">
        <span class="font-medium text-red-800">Total a castigar:</span>
        <span class="text-xl font-bold text-red-600">{{ selectedEnrollment.currencySymbol }}{{ selectedTotalAmount | number:'1.2-2' }}</span>
      </div>
      <div class="text-sm text-red-700 mt-1">{{ selectedInstallments.length }} cuotas seleccionadas</div>
    </div>

    <div class="flex justify-between mt-6">
      <button (click)="prevStep()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
        Anterior
      </button>
      <button 
        (click)="nextStep()" 
        [disabled]="selectedInstallments.length === 0"
        class="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed">
        Continuar
      </button>
    </div>
  </div>

  <!-- Paso 3: Confirmar -->
  <div *ngIf="currentStep === 3 && selectedEnrollment" class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-lg font-semibold mb-4">Confirmar Retiro</h2>
    
    <!-- Resumen del retiro -->
    <div class="bg-gray-50 rounded-lg p-4 mb-6">
      <h3 class="font-medium text-gray-700 mb-2">Resumen del Retiro</h3>
      <div class="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span class="text-gray-500">Participante:</span>
          <span class="ml-2 font-medium">{{ selectedEnrollment.participantName }}</span>
        </div>
        <div>
          <span class="text-gray-500">Proyecto:</span>
          <span class="ml-2 font-medium">{{ selectedEnrollment.projectMnemonic }}</span>
        </div>
        <div>
          <span class="text-gray-500">Cuotas a castigar:</span>
          <span class="ml-2 font-medium">{{ selectedInstallments.length }}</span>
        </div>
        <div>
          <span class="text-gray-500">Monto total:</span>
          <span class="ml-2 font-medium text-red-600">{{ selectedEnrollment.currencySymbol }}{{ selectedTotalAmount | number:'1.2-2' }}</span>
        </div>
      </div>
    </div>

    <form [formGroup]="confirmForm" (ngSubmit)="submitWithdrawal()">
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Razón del retiro *</label>
        <textarea 
          formControlName="reason"
          rows="3"
          placeholder="Ingrese la razón del retiro (mínimo 10 caracteres)"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          [ngClass]="{'border-red-500': confirmForm.get('reason')?.invalid && confirmForm.get('reason')?.touched}">
        </textarea>
        <div *ngIf="confirmForm.get('reason')?.invalid && confirmForm.get('reason')?.touched" class="text-red-500 text-sm mt-1">
          La razón es requerida y debe tener al menos 10 caracteres
        </div>
      </div>

      <div class="mb-6">
        <label class="block text-sm font-medium text-gray-700 mb-1">Notas adicionales (opcional)</label>
        <textarea 
          formControlName="notes"
          rows="2"
          placeholder="Notas adicionales para auditoría"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
        </textarea>
      </div>

      <!-- Advertencia -->
      <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-yellow-700">
              <strong>Importante:</strong> Esta acción castigará las cuotas seleccionadas y cambiará el estado de la inscripción a "Retirada". 
              Las cuotas castigadas no aparecerán en los reportes de cartera regular.
            </p>
          </div>
        </div>
      </div>

      <div class="flex justify-between">
        <button type="button" (click)="prevStep()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
          Anterior
        </button>
        <div class="flex items-center gap-3">
          <button type="button" (click)="cancel()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
            Cancelar
          </button>
          <button 
            type="submit" 
            [disabled]="confirmForm.invalid || isSubmitting"
            class="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed inline-flex items-center gap-2">
            <svg *ngIf="isSubmitting" class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span *ngIf="isSubmitting">Procesando...</span>
            <span *ngIf="!isSubmitting">Confirmar Retiro</span>
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- 🆕 Paso 4: Resultado Final -->
  <div *ngIf="currentStep === 4" class="bg-white rounded-lg shadow-md p-6">
    <!-- Éxito -->
    <div *ngIf="operationSuccess" class="text-center">
      <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
        <svg class="h-12 w-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
      </div>
      <h2 class="text-2xl font-bold text-gray-900 mb-2">¡Retiro Procesado Exitosamente!</h2>
      <p class="text-gray-600 mb-6">{{ operationResult?.message }}</p>

      <!-- Resumen de la operación -->
      <div class="bg-gray-50 rounded-lg p-6 text-left mb-6 max-w-lg mx-auto">
        <h3 class="font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          Resumen del Retiro
        </h3>
        <div class="space-y-3">
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Participante:</span>
            <span class="font-medium">{{ selectedEnrollment?.participantName }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Proyecto:</span>
            <span class="font-medium">{{ selectedEnrollment?.projectMnemonic }} - {{ selectedEnrollment?.projectName }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Cuotas Castigadas:</span>
            <span class="font-medium text-red-600">{{ operationResult?.affectedInstallmentsCount }} cuota(s)</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Monto Total Castigado:</span>
            <span class="font-bold text-red-600">{{ selectedEnrollment?.currencySymbol }}{{ operationResult?.totalAffectedAmount | number:'1.2-2' }}</span>
          </div>
          <div class="flex justify-between items-center py-2">
            <span class="text-gray-600">Nuevo Estado:</span>
            <span class="px-3 py-1 bg-red-100 text-red-800 rounded-full text-sm font-medium">Retirada</span>
          </div>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <button 
          (click)="viewEnrollment()" 
          class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
          </svg>
          Ver Inscripción
        </button>
        <button 
          (click)="startNewWithdrawal()" 
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          Nuevo Retiro
        </button>
        <button 
          (click)="goToEnrollmentsList()" 
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"/>
          </svg>
          Lista de Inscripciones
        </button>
      </div>
    </div>

    <!-- Error -->
    <div *ngIf="!operationSuccess" class="text-center">
      <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-red-100 mb-6">
        <svg class="h-12 w-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </div>
      <h2 class="text-2xl font-bold text-gray-900 mb-2">Error al Procesar el Retiro</h2>
      <p class="text-red-600 mb-6">{{ operationError }}</p>

      <!-- Botones de acción -->
      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <button 
          (click)="currentStep = 3" 
          class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
          </svg>
          Volver a Intentar
        </button>
        <button 
          (click)="goToEnrollmentsList()" 
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
